<template lang="pug">
v-list
  v-list-item(v-if="info.number")
    v-list-item-icon: v-icon mdi-file-document
    v-list-item-content
      v-list-item-title {{ info.number }}
      v-list-item-subtitle Номер договора

  v-list-item(
    v-if="info.login"
  )
    v-list-item-icon: v-icon mdi-account
    v-list-item-content
      v-list-item-title {{ info.login }}
      v-list-item-subtitle Логин
  v-list-item(
    v-if="info.full_name"
  )
    v-list-item-icon: v-icon mdi-account
    v-list-item-content
      v-list-item-title {{ info.full_name }}
      v-list-item-subtitle ФИО
  v-list-item(
    v-if="info.email"
    link
    target="_blank"
    :href="`mailto:${info.email}`"
  )
    v-list-item-icon: v-icon mdi-email
    v-list-item-content
      v-list-item-title {{ info.email }}
      v-list-item-subtitle Почта
  v-list-item(
    v-if="info.address"
  )
    v-list-item-icon: v-icon mdi-home
    v-list-item-content
      v-list-item-title {{ info.address }}
      v-list-item-subtitle Адрес
  v-list-item(
    v-if="info.phone"
    link
    :href="`tel:${info.phone | phoneHref}`"
    target="_blank"
  )
    v-list-item-icon: v-icon mdi-phone
    v-list-item-content
      v-list-item-title {{ info.phone | phone }}
      v-list-item-subtitle Телефон
  v-list-item(
    v-if="info.customer_contact_email"
    link
    target="_blank"
    :href="`mailto:${info.customer_contact_email}`"
  )
    v-list-item-icon: v-icon mdi-mail
    v-list-item-content
      v-list-item-title {{ info.customer_contact_email }}
      v-list-item-subtitle Почта

  v-list-item(
    v-if="info.telegram"
    link
    :href="`https://t.me/${info.telegram}`"
    target="_blank"
  )
    v-list-item-icon: v-icon(color="primary") $telegram
    v-list-item-content
      v-list-item-title {{ info.telegram }}
      v-list-item-subtitle Telegram

</template>
<script>
export default {
  props: {
    info: { type: Object, required: true },
  },
};
</script>
